var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.dashboard.description)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }